module.exports = __webpack_public_path__ + "static/media/logo.5ce29ee7.png";